module.exports = [{
      plugin: require('/home/travis/build/JSConfBp/2019.jsconfbp.com/node_modules/gatsby-mdx/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/JSConfBp/2019.jsconfbp.com/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/JSConfBp/2019.jsconfbp.com/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-58489830-1"},
    },{
      plugin: require('/home/travis/build/JSConfBp/2019.jsconfbp.com/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
